@if (treatmentPlanning()) {
  <div class="comparison-container">
    <div class="panel">
      @if (treatmentPlanning().selectedPlan$ | async; as selectedPlan) {
        <div class="panel-header">
          <h3 class="panel-title">
            @if (selectedPlan.name) {
              <span [textContent]="selectedPlan.name"></span>
            } @else if (selectedPlan.createdAt) {
              <span>{{
                selectedPlan.createdAt | moment | amDateFormat: dateFormat
              }}</span>
            } @else {
              <span>Treatment Plan</span>
            }
          </h3>
          <button
            mat-stroked-button
            type="button"
            (click)="changeSelectedPlan()"
          >
            Change Plan
          </button>
        </div>
        <div class="panel-content">
          <pr-treatment-steps-editor
            [currentPlan]="selectedPlan"
            [patient]="patient$() | async"
            [flaggedTreatments]="emptyProposal"
            [showPlanView]="true"
            [showFlaggedTreatments]="false"
          />
        </div>
      }
    </div>

    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-title">
          @if (treatmentPlanning().comparisonPlan$ | async; as comparisonPlan) {
            @if (comparisonPlan.name) {
              <span [textContent]="comparisonPlan.name"></span>
            } @else if (comparisonPlan.createdAt) {
              <span>{{
                comparisonPlan.createdAt | moment | amDateFormat: dateFormat
              }}</span>
            } @else {
              <span>Treatment Plan</span>
            }
          } @else {
            <span>Compare Plan</span>
          }
        </h3>
        <button
          mat-stroked-button
          type="button"
          (click)="changeComparisonPlan()"
        >
          Change Plan
        </button>
      </div>

      <div class="panel-content">
        @if (treatmentPlanning().comparisonPlanLoading$ | async) {
          <div class="empty-state">
            <mat-spinner diameter="40" />
          </div>
        } @else {
          @if (treatmentPlanning().comparisonPlan$ | async; as comparisonPlan) {
            <pr-treatment-steps-editor
              [currentPlan]="comparisonPlan"
              [patient]="patient$() | async"
            [flaggedTreatments]="emptyProposal"
              [showPlanView]="true"
              [showFlaggedTreatments]="false"
            />
          } @else {
            <div class="empty-state">
              <pr-empty-state
                image="list"
                explicitTitle="No Plan Selected"
                description="Select a treatment plan to compare side by side"
              />
              <button
                mat-flat-button
                color="primary"
                type="button"
                (click)="changeComparisonPlan()"
              >
                Select Plan
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>
}
